import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraButton } from './button';
// sm matches SpecraButton sm and --control-height-sm, so an icon button sits
// level with the buttons beside it in a dense toolbar.
const sizeClass = {
    sm: 'size-[var(--control-height-sm)]',
    default: 'size-[var(--control-height-md)]',
    lg: 'size-[var(--control-height-lg)]'
};
/** Icon-only action with an enforced accessible label. */ export const SpecraIconButton = /*#__PURE__*/ React.forwardRef(({ children, className, label, size = 'default', title, ...props }, ref)=>/*#__PURE__*/ _jsx(SpecraButton, {
        ref: ref,
        "aria-label": label,
        className: cn(sizeClass[size], 'p-0', className),
        size: "icon",
        title: title ?? label,
        ...props,
        children: children
    }));
SpecraIconButton.displayName = 'SpecraIconButton';
